export default __webpack_public_path__ + "assets/images/2b8c79516ad824263f045259ef94ee50.webp";